/*
  Mobile size-popup toggle for product cards.

  Tab-switching (UK/US/EU) on those cards is now handled by tab-panel.js
  via the enhanceCardSizeTabs() function — this file only manages the
  mobile "Sizes" pill that opens the popup on small screens.
*/
document.addEventListener("DOMContentLoaded", function () {
  const popupOpen = document.querySelectorAll(
    ".mobile-size-hover__toggle-container"
  );
  const popupMobiles = document.querySelectorAll(".product-variants-container");

  if (
    popupOpen.length === 0 ||
    popupMobiles.length === 0 ||
    popupOpen.length !== popupMobiles.length
  ) {
    return;
  }

  let activeIndex = -1;

  for (let i = 0; i < popupOpen.length; i++) {
    popupOpen[i].addEventListener("click", (event) => {
      event.stopPropagation();
      if (activeIndex !== -1 && activeIndex !== i) {
        popupMobiles[activeIndex].classList.remove("active");
        popupOpen[activeIndex].style.display = "block";
      }
      popupMobiles[i].classList.add("active");
      popupOpen[i].style.display = "none";
      activeIndex = i;
    });
  }

  document.body.addEventListener("click", (event) => {
    for (let i = 0; i < popupMobiles.length; i++) {
      if (
        !popupMobiles[i].contains(event.target) &&
        !popupOpen[i].contains(event.target)
      ) {
        popupMobiles[i].classList.remove("active");
        popupOpen[i].style.display = "block";
        activeIndex = -1;
      }
    }
  });

  window.addEventListener("scroll", () => {
    for (let i = 0; i < popupMobiles.length; i++) {
      popupMobiles[i].classList.remove("active");
      popupOpen[i].style.display = "block";
      activeIndex = -1;
    }
  });
});
